import call from './call';
import {GET_WEB_SERVICE_USERS} from "../types";

export default () => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
            dispatch({type: GET_WEB_SERVICE_USERS, payload: {entries: result[1].results,total:result[1].total, kind:'webservices'}});
    };
    dispatch(call("UserService/getAllWSUsers",{},onResult));
};